import { createContext, useEffect } from "react";
import { useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { useLocation } from "react-router-dom";
import SubsidiosService from "../../../../services/solicitudes/SubsidiosService";
import { CustomStepWizard } from "../../../generico/CustomStepWizard";
import Titulo from "../../../generico/TituloPagina";
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import { PagoSepelioPaso1 } from "./PagoSepelioPaso1";
import { PagoSepelioPaso2 } from "./PagoSepelioPaso2";
import Popup from "react-popup";
import { PagoSepelioPaso3 } from "./PagoSepelioPaso3";
import PagoSepelioService from "../../../../services/pagos/PagoSepelioService";
import authService from "../../../../services/login/auth.service";

export const SepelioContext = createContext();

export const PagoSepelio = () => {

    const location = useLocation();
    let param = null;

    if (location.state) param = location.state.param;

    const initialState = {
        cuentasOrigen: [],
        ctaOrigenSele: { value: "-1", label: "--Seleccione--" },
        itemSelected: { value: "-1", label: "--Seleccione--" },
        ctaFullData: null,
        moneda: "",
        desdeMenu: true,
        infoPagare: null,
        pagareList: [],
        codOperacion: ""
    }

    const [state, setState] = useState({
        ...initialState,
        desdeMenu: param === null,
        infoPagare: param
    });

    useEffect(() => {
        getCuentas();
    }, []);


    const notifiPopup = (titulo, mensaje) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: function () {
                            Popup.close();
                        },
                    },
                ],
            },
        });

    const resetState = () => {
        setState(initialState);
        getCuentas();
    }

    const getCuentas = () => {
        trackPromise(
            SubsidiosService.getCuentas().then(response => {
                let { codigo, mensaje, resultadoAH } = response.data;
                if (codigo === "0") {
                    let cuentasMap = resultadoAH.map(value => ({
                        ...value,
                        idAhorro: value.ahorro,
                        disponible: value.saldoTotal
                    }));
                    setState(prevState => ({ ...prevState, cuentasOrigen: cuentasMap, moneda: "GS" }));
                } else {
                    Popup.queue(notifiPopup("Info", mensaje));
                }
            })
        );
    }

    const getPagareList = () => {
        PagoSepelioService.getPagareSepelio().then(response => {
            let { codigoRetorno, mensajeRetorno, datos } = response.data;
            if (codigoRetorno === "0") {
                if (datos.length > 1) {
                    setState(prevState => ({ ...prevState, pagareList: datos }));
                } else {
                    setState(prevState => ({
                        ...prevState,
                        infoPagare: datos.length === 1 ? datos[0] : null,
                        importe: formatoSeparadorMilesValue(datos[0]?.montoAPagar),
                    }));
                }
            } else {
                Popup.queue(notifiPopup("Info", mensajeRetorno));
            }
        })
    }

    const descargarComprobante = () => {

        let { numeroSocio, nombreCompleto } = authService.getSocio();

        trackPromise(
            PagoSepelioService.descargarComprobante(
                "Pago de Sepelio",
                state.codOperacion,
                `${numeroSocio} - ${nombreCompleto}`,
                `${state.ctaFullData.idAhorro} - ${state.ctaFullData.descripcion}`,
                state.moneda,
                formatoSeparadorMilesValue(state.infoPagare.montoAPagar),
                state.infoPagare.idSolicitud,
                state.infoPagare.nombreEmpresa
            )
                .then((response) => {
                    var fileURL = URL.createObjectURL(response.data);
                    window.open(fileURL, "");
                })
                .catch(function (error) {
                    console.log(error);
                })
        )
    }

    const sepelioContextValue = { state, setState, resetState, getCuentas, getPagareList, descargarComprobante }

    const stepWizardHeaders = ["Datos de Pago", "Datos de Verificación", "Confirmación"];

    return (
        <div className="content-wrapper">
            <Titulo texto="Pago de Sepelio" />
            <section className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <CustomStepWizard contextValue={sepelioContextValue} isLazyMount={true} stepHeaders={stepWizardHeaders} >
                                        <PagoSepelioPaso1 />
                                        <PagoSepelioPaso2 />
                                        <PagoSepelioPaso3 />
                                    </CustomStepWizard>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}